import React from 'react'

import styles from 'containers/common/appHeader/AppHeader.module.scss'
import { ReactComponent as LogoIcon } from 'assets/icons/logo.svg'

export const AppHeader = () => (
  <header className={styles.header}>
    <div className={styles.content}>
      <LogoIcon width="125" height="35" />
    </div>
  </header>
)

AppHeader.propTypes = {}
